import {Directive, ElementRef, forwardRef, HostListener, Input} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {MAT_INPUT_VALUE_ACCESSOR} from '@angular/material/input';
import clearSpaces from './clear-spaces';

@Directive({
  selector: 'input[appClearSpaces]',
  providers: [
    {
      provide: MAT_INPUT_VALUE_ACCESSOR,
      useExisting: ClearSpacesDirective
    },
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ClearSpacesDirective),
      multi: true
    }
  ]
})
export class ClearSpacesDirective implements ControlValueAccessor {

  private inputValue = '';
  private element: HTMLInputElement;
  private onChange!: (val: any) => void;
  private onTouched!: () => void;

  constructor(
    private elementRef: ElementRef,
  ) {
    this.element = this.elementRef.nativeElement;
  }

  writeValue(value: any): void {
    this.inputValue = clearSpaces(value);
    this.element.value = this.inputValue;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    throw new Error('Method not implemented.');
  }

  get value(): string {
    return this.inputValue as string;
  }

  @Input() //'value'
  set value(value: string) {
    this.inputValue = clearSpaces(value);
    this.element.value = this.inputValue;
  }

  @HostListener('input', ['$event.target.value'])
  onInput(value: string): void {
    this.inputValue = value;
    this.onChange(clearSpaces(value));
  }

  @HostListener('blur', ['$event.target.value'])
  onBlur(value: string): void {
    this.inputValue = clearSpaces(value);
    this.element.value = this.inputValue;
    this.onTouched();
  }
}
